import { useAppSelector } from '@/shared/lib/redux'
import { StatisticsBlock } from '@/shared/ui/statistics-block'
import BankSvg from '@/shared/assets/images/Bank.svg'
import TransferSvg from '@/shared/assets/images/ArrowsLeftRight.svg'
import CurrencySvg from '@/shared/assets/images/CurrencyRub.svg'
import { selectPartnersStatisticsAggregates } from '../../model'
import { toLocaleString } from '@/shared/lib/to-locale-string'

export const TotalStatistics = () => {
    const statistics = useAppSelector(selectPartnersStatisticsAggregates)
    return (
        <div className='flex flex-col gap-4'>
            <StatisticsBlock 
                icon={TransferSvg}
                label='Количество  транзакций' 
                value={toLocaleString(statistics.countTransactions ?? 0)}
            />
            <StatisticsBlock
                icon={BankSvg}
                label='Сумма  транзакций' 
                value={toLocaleString(statistics.total ?? 0)}
            />
            <StatisticsBlock 
                icon={CurrencySvg}
                label='Сумма бонусных скидок' 
                value={toLocaleString(statistics.bonusTotal ?? 0)}
            />
        </div>
    )
}